import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

import { PageHeaderComponent } from '../../../shared/components/ui/page-header/page-header.component';
import { toErrorMessage } from '../../../shared/helpers/http-error';
import { OptionsService } from '../../../shared/services/options.service';
import { VehicleOptionWriteRequest } from '../../../shared/types/option.types';
import { OptionFormComponent } from '../option-form/option-form.component';

@Component({
  selector: 'app-option-create',
  imports: [PageHeaderComponent, OptionFormComponent],
  templateUrl: './option-create.component.html',
})
export class OptionCreateComponent {
  private readonly service = inject(OptionsService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  readonly submitting = signal(false);
  readonly serverError = signal<string | null>(null);

  onSave(payload: VehicleOptionWriteRequest): void {
    this.submitting.set(true);
    this.serverError.set(null);
    this.service
      .create(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (created) => {
          this.submitting.set(false);
          void this.router.navigate(
            created.id ? ['/options', created.id] : ['/options'],
          );
        },
        error: (err: unknown) => {
          this.submitting.set(false);
          this.serverError.set(
            toErrorMessage(err, 'La création a échoué.', {
              409: 'Un équipement avec ce slug existe déjà.',
            }),
          );
        },
      });
  }

  onCancel(): void {
    void this.router.navigate(['/options']);
  }
}
